import { LiveClassData } from '../initial.state';
import * as actionTypes from '../actions/types';

export const LiveClassesReducer = (state = new LiveClassData(), { type, response }) => {
  switch (type) {
    case actionTypes.GET_TODAY_LIVE_CLASSES_DATA:
      return { ...state, liveClasses: { ...state.liveClasses, today: response.data } };
    case actionTypes.GET_UPCOMING_LIVE_CLASSES_DATA:
      return { ...state, liveClasses: { ...state.liveClasses, upcoming: response.data } };
    case actionTypes.GET_COMPLETED_LIVE_CLASSES_DATA:
      return { ...state, liveClasses: { ...state.liveClasses, completed: response.data } };
    case actionTypes.GET_ALL_ZOOM_ACCOUNTS:
      return { ...state, zoomAccounts: response.data.data };
    case actionTypes.GET_ALL_BATCH_SUBJECTS:
      return { ...state, subjects: response.data.data };
    case actionTypes.GET_ALL_LIVE_BATCHES:
      return { ...state, batches: response.data.data };
    case actionTypes.GET_ALL_BATCH_CHAPTERS:
      return { ...state, chapters: response.data.data };
    case actionTypes.START_LIVE_CLASS:
      return { ...state, liveClassStartData: response.data.data };
    case actionTypes.CREATE_BATCH_SUBJECT:
      return {
        ...state,
        subjects: [...state.subjects, response.data.data],
        newSubject: response.data.data,
      };
    case actionTypes.CREATE_BATCH_CHAPTER:
      return {
        ...state,
        chapters: [...state.chapters, response.data.data],
        newChapter: response.data.data,
      };
    default:
      return state;
  }
};
